module.exports = __webpack_public_path__ + "img/menuLogoDark.86aaa1e9.png";